/* eslint-disable */
export default {
  DirectNumber: 'Diretto',
  MainCompanyNumber: 'Principale',
  CompanyNumber: 'Azienda',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Bloccato',
  AdditionalCompanyNumber: 'Azienda',
  ForwardedCompanyNumber: 'Trasferito',
  from: 'Da',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
